import { useState } from 'react'
import type { ClientSummary } from '../data/types'

function initials(client: Pick<ClientSummary, 'firstName' | 'lastName'>): string {
  const f = (client.firstName || '').trim()[0] || ''
  const l = (client.lastName || '').trim()[0] || ''
  return (l + f).toUpperCase() || '?'
}

type Props = {
  client: Pick<ClientSummary, 'firstName' | 'lastName' | 'photoUrl'>
  size?: 'sm' | 'lg' | 'xl'
  className?: string
}

/** Client avatar with graceful fallback to colored initials. */
export function Avatar({ client, size, className = '' }: Props) {
  const [failed, setFailed] = useState(false)
  const sizeClass = size === 'lg' ? ' avatar--lg' : size === 'xl' ? ' avatar--xl' : ''
  const cls = `avatar${sizeClass} ${className}`.trim()

  if (client.photoUrl && !failed) {
    const base = import.meta.env.BASE_URL || './'
    const normalized = base.endsWith('/') ? base : `${base}/`
    const src = client.photoUrl.startsWith('/')
      ? `${normalized}${client.photoUrl.slice(1)}`
      : client.photoUrl
    return (
      <img
        className={cls}
        src={src}
        alt=""
        loading="lazy"
        onError={() => setFailed(true)}
      />
    )
  }
  return <span className={cls}>{initials(client)}</span>
}
